var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh",
    d: "M27.99908,15.83618A12.00008,12.00008,0,0,1,16.71484,27.97852c-.24414.01464-.48828.022-.73046.022a11.89341,11.89341,0,0,1-7.17121-2.39478L7.42542,27.16956a.5.5,0,0,1-.85975-.21326L5.08826,20.90479a.5.5,0,0,1,.54571-.615l6.18421.74732a.5.5,0,0,1,.314.82825L10.81372,23.3512A8.998,8.998,0,0,0,24.99817,15.798a1.07162,1.07162,0,0,1,.31824-.8341,1.03419,1.03419,0,0,1,.80731-.26123l1.00909.12207a1.08451,1.08451,0,0,1,.61676.3247A.93076.93076,0,0,1,27.99908,15.83618ZM6.68359,17.03613a1.07162,1.07162,0,0,0,.31824-.8341A8.99623,8.99623,0,0,1,21.18628,8.6488L19.8678,10.13464a.5.5,0,0,0,.314.82825l6.18421.74732a.5.5,0,0,0,.54571-.615L25.43433,5.0437a.5.5,0,0,0-.85975-.21326L23.18683,6.39429a11.89341,11.89341,0,0,0-7.17121-2.39478c-.24218,0-.48632.00733-.73046.022A12.00008,12.00008,0,0,0,4.00092,16.16382a.93076.93076,0,0,0,.24951.68677,1.08451,1.08451,0,0,0,.61676.3247l1.00909.12207A1.03419,1.03419,0,0,0,6.68359,17.03613Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e17e32784191d7f084d99fc3cc80753e.svg";
export { ForwardRef as ReactComponent };